// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nobMOVvpL_spQKUXVUIF {
	box-sizing: border-box;
	font-size: 16px;
	letter-spacing: -0.08em;
	line-height: 28px;
	padding: 4px 26.5px;
	height: 36px;
}

.gTBq4_syDluIWrQLPoEY {
	color: #fff;
	text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/pages/ClaimRewardsPage/BannerList/BannerList.pcss"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,0BAA0B;AAC3B","sourcesContent":[".goToRewardsButton {\n\tbox-sizing: border-box;\n\tfont-size: 16px;\n\tletter-spacing: -0.08em;\n\tline-height: 28px;\n\tpadding: 4px 26.5px;\n\theight: 36px;\n}\n\n.link {\n\tcolor: #fff;\n\ttext-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"goToRewardsButton": `nobMOVvpL_spQKUXVUIF`,
	"link": `gTBq4_syDluIWrQLPoEY`
};
export default ___CSS_LOADER_EXPORT___;
